export default "__VITE_ASSET__CE506_tZ__"